import fileUpload from '../../../../fileUpload'

export default function() {
  fileUpload();
};
